import React from 'react';
import { InputGroup } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { ControlWrapper, SearchWrapper } from 'components/styled-components';
import debounce from 'lodash/debounce';
import constants from 'utils/constants';

const Controls = ({ handleSearch }) => {
  const throttledSearch = debounce(
    handleSearch,
    constants.SEARCH_TYPING_DELAY_MILLISECONDS
  );

  const handleQueryChange = e => {
    throttledSearch(e.target.value);
  };

  return (
    <SearchWrapper padding="1rem 2rem">
      <ControlWrapper>
        <InputGroup
          leftIcon={IconNames.SEARCH}
          placeholder={`Search Users`}
          className="medium-text-group light-blue"
          onChange={handleQueryChange}
        />
      </ControlWrapper>
    </SearchWrapper>
  );
};

export default Controls;
